/** @jsxImportSource react */
import { Button } from '@react/system';
import { ButtonProps } from '@react/system/Button/button.types';
import { useFormState } from 'react-final-form';

export default function SubmitButton({ children, ...props }: ButtonProps) {
  const {
    submitting,
    pristine,
    hasValidationErrors,
    submitFailed,
    modifiedSinceLastSubmit,
  } = useFormState();

  return (
    <Button
      disabled={
        pristine ||
        hasValidationErrors ||
        submitting ||
        (submitFailed && !modifiedSinceLastSubmit)
      }
      {...props}
    >
      {children}
    </Button>
  );
}
